/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {IS_PROD} from "helpers/config";
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import "./assets/main.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "helpers/store";
import {Provider} from "react-redux";
import history from "helpers/history";
import {Router} from "react-router-dom";
import * as Sentry from "@sentry/react";
import SuspenseLoader from "components/SuspenseLoader";
import matchAll from "string.prototype.matchall";

import "helpers/i18n";

if (IS_PROD) {
    const SENTRY_RELEASE = process.env.REACT_SENTRY_PROJECT + "@" + process.env.REACT_APP_VERSION;

    Sentry.init({
        dsn: "https://ba337718eebfbcf8adc6c55c5af816cc@o4506553343475712.ingest.sentry.io/4506593216954368",
        release: SENTRY_RELEASE,
        ignoreErrors: [/Non-Error promise rejection captured with keys: config, dat/, /Unexpected token '<'/, /Illegal invocation/],
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
            }),
        ],
        replaysOnErrorSampleRate: 1,
        tracesSampleRate: 0.1,
    });
}

matchAll.shim();
const Root: React.FC = () => {
    return (
        <Suspense fallback={<SuspenseLoader />}>
            <Provider store={store}>
                <Router history={history}>
                    <App />
                </Router>
            </Provider>
        </Suspense>
    );
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
